// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_e2_","cls2":"ReferenceCard-cls2_mCU ReferenceCard-cls1_e2_"};